import dashboard from './dashboard';
import utilities from './utilities';
import other from './other';
import inquiry from './inquiry';
import conversation from './conversation';
import payment from './payment';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [
        dashboard,
        utilities,
        conversation,
        other,
        inquiry,
        payment
    ]
};

export default menuItems;